if (!customElements.get('mobile-buy-bar')) {
  customElements.define('mobile-buy-bar', class MobileBuyBar extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.querySelector(`#${this.dataset.mainForm} [type="submit"]`);
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => this.mainButton?.click());
      if (!this.mainButton) return;
      this.observer = new IntersectionObserver(([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
      this.observer.observe(this.mainButton);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

if (!customElements.get('campaign-bundle')) {
  customElements.define('campaign-bundle', class CampaignBundle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.campaign-bundle__button');
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.radios.forEach((radio) => radio.addEventListener('change', () => {
        this.querySelectorAll('.campaign-bundle__product').forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
        this.button.disabled = false;
      }));
      this.button.addEventListener('click', () => this.addBundle());
    }

    async addBundle() {
      const selected = this.querySelector('input[type="radio"]:checked');
      const mainVariant = document.querySelector(`#${this.dataset.mainForm} [name="id"]`);
      const quantity = document.querySelector(`[form="${this.dataset.mainForm}"][name="quantity"]`);
      if (!selected || !mainVariant?.value) return;
      this.button.disabled = true;
      this.button.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(mainVariant.value), quantity: Number(quantity?.value || 1) },
            { id: Number(selected.value), quantity: 1 }
          ] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Kunne ikke legge produktene i handlekurven.');
        window.location.href = this.dataset.cartUrl;
      } catch (error) {
        const message = this.querySelector('.campaign-bundle__error');
        message.textContent = error.message;
        message.hidden = false;
        this.button.disabled = false;
        this.button.classList.remove('loading');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  });
}
